@use "../../../../src/styles/Colors.scss" as Colors;
@use "../../../../src/styles/Constants.scss" as Constants;

$var-border: 1px solid Colors.$col-greyConnection;
$var-table-header-height: 64px;

.tree-table {
	background: Colors.$col-white;
	border-radius: Constants.$val-borderRadius;

	.tree-table-row {
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		display: flex;
		align-items: center;
		border-bottom: $var-border;
	}

	.category-name{
		display: flex;
		align-items: center;
	}

	.directory-attachment-icon {
		user-select: text;
		font-size: Constants.$val-fontSizeXXBig;
	} 

	.directory-attachment-name {
		margin-left: Constants.$val-inputPadding-tb
	}

	.expand-icon-cell {
		font-size: large;
	}

	.cell-flex-05 {
		flex: 0.5;
		justify-content: center;
		display: flex;
	}

	.cell-flex-1 {
		flex: 1;
		justify-content: center;
		display: flex;
	}

	.cell-flex-2 {
		flex: 2;
		justify-content: center;
		display: flex;
	}

	.cell-flex-3 {
		flex: 3;
		justify-content: center;
		display: flex;
	}

	.upload-icon,
	.download-icon,
	.preview-icon {
		width: 15px;
		font-size: 20px;
		transition: color 0.1s;
		cursor: pointer;

		&:hover {
			color: Colors.$col-blue;
		}
	}


	.linked-wo-list-container {
		color: Colors.$col-blue;
		justify-content: left;

		.expander {
			cursor: pointer;

			.expander-icon {
				margin-right: Constants.$val-spacing-s;
			}

			.wo-counter {
				margin-left: Constants.$val-spacing-s;
			}
		}

		.wo-list {
			margin-top: Constants.$val-spacing-s;

			.wo-link {
				color: Colors.$col-blue;
				display: block;

				.external-icon {
					margin-right: Constants.$val-spacing-s;
				}
			}
		}
	}
}

.modal {
	width: Constants.$val-modal-xl !important;
	display: flex !important;
	justify-content: center !important;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);

	&__big-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: Constants.$val-fontSizeXBig;
		font-weight: bold;
		overflow: initial !important;

		&::before,
		&::after {
			display: none;
		}

		&__thin {
			font-size: Constants.$val-fontSizeXBig;
			font-weight: normal;
		}
	}

	&__body {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.img-preview {
		max-height: 500px;
		max-width: 600px;
	}
}

.settings-actions {
	font-size: Constants.$val-fontSizeXXXBig;

	&__dropdown-toggle {
		color: Colors.$col-black;
		justify-content: center;
		cursor: pointer;

		&:focus,
		&:hover,
		&:active,
		&:active:hover,
		&:active:focus {
			color: Colors.$col-black;
		}
	}
}

input {
	&.input-text-field {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		background-color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		outline: none;
		height: Constants.$val-fieldSize;
		width: -webkit-fill-available;
	}
}

.drag-drop-style {
	background-color: Colors.$col-design-orange5;
	outline-color: Colors.$col-orangeBorder;
	outline-style: dashed;
}

.child-color {
	background-color: Colors.$col-orange-100;
}